import { render, staticRenderFns } from "./FileReview.vue?vue&type=template&id=06aaee4e&scoped=true&"
import script from "./FileReview.vue?vue&type=script&lang=js&"
export * from "./FileReview.vue?vue&type=script&lang=js&"
import style0 from "./FileReview.vue?vue&type=style&index=0&id=06aaee4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aaee4e",
  null
  
)

export default component.exports